export default __webpack_public_path__ + "static/media/ci-segment-occasional.f79cfe08.svg";